import { render, staticRenderFns } from "./render-checkboxes.vue?vue&type=template&id=0957c0d2&scoped=true&"
import script from "./render-checkboxes.vue?vue&type=script&lang=ts&"
export * from "./render-checkboxes.vue?vue&type=script&lang=ts&"
import style0 from "./render-checkboxes.vue?vue&type=style&index=0&id=0957c0d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0957c0d2",
  null
  
)

export default component.exports